import React from 'react';
import {
  Navigate,
  Route, Routes,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import './i18n';
import UserLayout from 'screens/User/Layout';
import AdminLayout from 'screens/Admin/Layout';
import LoginSso from 'screens/LoginSso';
import LinkInvitation from 'screens/LinkInvitation';
import RecoverPassword from 'screens/RecoverPassword';
import { selectUser } from 'store/User';
import AppCommon from 'AppCommon';
import LinkValidateEmail from 'screens/LinkValidateEmail';
import ForceChangePassword from './screens/ForceChangePassword';

function PrivateRoute( { children, isLoggedIn }: { children: JSX.Element, isLoggedIn: boolean } ) {
  if ( !isLoggedIn ) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  return children;
}

function PublicRoute( { children, isLoggedIn }: { children: JSX.Element, isLoggedIn: boolean } ) {
  if ( isLoggedIn ) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  return children;
}

function App() {
  const user = useSelector( selectUser );
  const isLoggedIn = !!( user?.accessToken && user?.account );

  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={(
            <PublicRoute isLoggedIn={isLoggedIn}>
              <LoginSso />
            </PublicRoute>
          )}
        />
        <Route
          path="/login-sso"
          element={(
            <PublicRoute isLoggedIn={isLoggedIn}>
              <LoginSso />
            </PublicRoute>
          )}
        />
        <Route
          path="/recover-password"
          element={(
            <PublicRoute isLoggedIn={isLoggedIn}>
              <RecoverPassword />
            </PublicRoute>
          )}
        />
        <Route
          path="/force-change-password"
          element={(
            <PublicRoute isLoggedIn={isLoggedIn}>
              <ForceChangePassword />
            </PublicRoute>
          )}
        />
        <Route
          path="/link/informacion-confidencial/:uuid"
          element={(
            <LinkInvitation />
          )}
        />
        <Route
          path="/link/validando-invitacion/:uuid"
          element={(
            <LinkValidateEmail />
          )}
        />

        {user?.role === 'Admin' ? (
          <Route
            path="/admin/*"
            element={(
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <AdminLayout />
              </PrivateRoute>
              )}
          />
        ) : null}

        <Route
          path="/*"
          element={(
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <UserLayout />
            </PrivateRoute>
        )}
        />
      </Routes>

      <AppCommon />
    </>
  );
}

export default App;
